import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Row,
  Table,
  Input,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Spinner,
  Label,
} from "reactstrap";
import { isIterableArray } from "../../helpers/utils";
import FalconCardHeader from "../common/FalconCardHeader";
import PageHeader from "../common/PageHeader";
import FullPagination from "../common/pagination/FullPagination";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import {
  getAllVisitorRegistered,
  visitorCheckOut,
} from "../../helpers/api/visitors";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import {
  faCheck,
  faClock,
  faFilter,
  faInfoCircle,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import Flex from "../common/Flex";
import DatetimeRangePicker from "react-datetime-range-picker";
import ButtonIcon from "../common/ButtonIcon";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import classNames from "classnames";
import { Toast } from "../UI/toast/Toast";
import moment from "moment";
import SupportLink from "../root/support/components/SupportLink";

const VisitorsHistory = () => {
  const history = useHistory();

  const [submitting, setSubmitting] = useState(false);

  const [collapseOne, collapseOneOpen] = useState(false);

  const [visitorId, setVisitorId] = useState(null);
  const {
    condominium: { selectedCondominium },
    auth: {
      user: { role },
    },
  } = useSelector((state) => state);

  const [textVisitor, setTextVisitor] = useState("");
  const [textProperty, setTextProperty] = useState("");
  const [hourValue, setHourValue] = useState({
    start_at: null,
    end_at: null,
  });
  const [dateValue, setDateValue] = useState({
    start_at: null,
    end_at: null,
  });

  const [isOutside, setIsOutside] = useState(0);

  const [dateFormat, setDateFormat] = useState(null);
  const [searchProperty, setSearchProperty] = useState(false);
  const [searchVisitor, setSearchVisitor] = useState(false);
  const [searchDate, setSearchDate] = useState(false);

  const [filtersVisible, setfiltersVisible] = useState(false);

  const [params, setParams] = useState({
    deperture_time: null,
    search_visitor: null,
    search_property: null,
    entry_time_at: null,
    departure_time_at: null,
    entry_time_date: null,
    departure_time_date: null,
    condominium: role === "manager" ? selectedCondominium : null,
    departure_time: null,
  });

  const {
    data,
    error,
    isLoading,
    mutate,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(getAllVisitorRegistered, params);

  const markCheckOut = () => {
    setSubmitting(true);
    visitorCheckOut(visitorId)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          Toast.fire({
            type: "success",
            title: `Salida marcada exitosamente.`,
          });
          mutate();
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => {
        setSubmitting(false);
        setVisitorId(null);
        collapseOneOpen(false);
      });
  };

  const handleModalConfirm = () => (
    <Modal isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Confirmación</ModalHeader>
      <ModalBody>
        <Row>
          <Col tag={FormGroup}>
            <Label>¿Marcar salida de visitante?</Label>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => collapseOneOpen(false)}>Cancelar</Button>
        <Button
          data-testid="submit-button"
          color="primary"
          type="submit"
          disabled={submitting}
          onClick={markCheckOut}
        >
          Marcar salida {submitting && <Spinner size="sm" color="white" />}
        </Button>
      </ModalFooter>
    </Modal>
  );

  return (
    <>
      <PageHeader
        title="Historial de visitas"
        titleTag="h2"
        description={`Gestiona las entradas y salidas de los visitantes.`}
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <Card className="mb-3">
        <FalconCardHeader title="Historial de entradas">
          <Row className="flex-column justify-end">
            <Col xs={12}>
              <ButtonIcon
                icon={faFilter}
                className={classNames({ "mb-3": filtersVisible })}
                color={filtersVisible ? "primary" : "light"}
                onClick={() => {
                  setfiltersVisible(!filtersVisible);
                  setSearchDate(false);
                  setSearchProperty(false);
                  setSearchVisitor(false);
                }}
              >
                Filtrar
              </ButtonIcon>
            </Col>
            <Col xs={12}>
              {filtersVisible && (
                <>
                  <Row>
                    <Col className="mb-3">
                      <Row>
                        <Col
                          xs={12}
                          className="mr-2 bg-soft-light p-2 border-bottom"
                          tag={Flex}
                          align="center"
                          justify="between"
                        >
                          <Label className="mb-0">Fecha</Label>
                          <Input
                            type="checkbox"
                            value={searchDate}
                            onChange={({ target }) => {
                              setSearchDate(target.checked);
                              setDateValue(null);
                              setHourValue(null);
                              setDateFormat("date");
                            }}
                            className="position-relative mr-2 ml-2 mt-0 mb-0"
                          />
                        </Col>
                        {role !== "property" && (
                        <Col
                          xs={12}
                          className="mr-2 bg-soft-light p-2 border-bottom"
                          tag={Flex}
                          align="center"
                          justify="between"
                        >
                          <Label className="mb-0">Propietario</Label>
                          <Input
                            type="checkbox"
                            value={searchProperty}
                            onChange={({ target }) => {
                              setSearchProperty(target.checked);
                              setTextProperty("");
                              if (!target.checked) {
                                setParams((prev) => ({
                                  ...prev,
                                  search_property: null,
                                }));
                              }
                            }}
                            className="position-relative mr-2 ml-2 mt-0 mb-0"
                          />
                        </Col>
                        )}
                        <Col
                          xs={12}
                          tag={Flex}
                          align="center"
                          justify="between"
                          className="mr-2 bg-soft-light p-2 border-bottom"
                        >
                          <Label className="mb-0">Visitante / Autorizado</Label>
                          <Input
                            type="checkbox"
                            value={searchVisitor}
                            onChange={({ target }) => {
                              setSearchVisitor(target.checked);
                              setTextVisitor("");
                              if (!target.checked) {
                                setParams((prev) => ({
                                  ...prev,
                                  search_visitor: null,
                                }));
                              }
                            }}
                            className="position-relative mr-2 ml-2 mt-0 mb-0"
                          />
                        </Col>
                        <Col
                          xs={12}
                          align="center"
                          justify="between"
                          className="mr-2 bg-soft-light p-2 border-bottom"
                          tag={Flex}
                        >
                          <Label className="mb-0 mr-2">Mostrar por</Label>
                          <Input
                            type="select"
                            value={isOutside}
                            onChange={({ target }) => {
                              setIsOutside(target.value);
                            }}
                          >
                            <option value={0}>Todos</option>
                            <option value={1}>Ha salido</option>
                            <option value={2}>No ha salido</option>
                          </Input>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    {searchVisitor && (
                      <Col className="d-flex" tag={FormGroup}>
                        <Input
                          type="text"
                          value={textVisitor}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              const term = e.target.value.trim();
                              setParams((prev) => ({
                                ...prev,
                                search_visitor: term || null,
                              }));
                            }
                          }}
                          onChange={(event) => {
                            const value = event.target.value;
                            setTextVisitor(value);
                            if (!value.trim()) {
                              setParams((prev) => ({
                                ...prev,
                                search_visitor: null,
                              }));
                            }
                          }}
                          placeholder="Buscar visitante por nombre, cédula, teléfono, correo o placa..."
                          className="search-input mr-2"
                        />
                      </Col>
                    )}
                    {searchProperty && role !== "property" && (
                      <Col className="d-flex" tag={FormGroup}>
                        <Input
                          type="text"
                          value={textProperty}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              const term = e.target.value.trim();
                              setParams((prev) => ({
                                ...prev,
                                search_property: term || null,
                              }));
                            }
                          }}
                          onChange={(event) => {
                            const value = event.target.value;
                            setTextProperty(value);
                            if (!value.trim()) {
                              setParams((prev) => ({
                                ...prev,
                                search_property: null,
                              }));
                            }
                          }}
                          placeholder="Buscar propietario por inmueble, nombre, usuario, cédula, teléfono o correo..."
                          className="search-input mr-2"
                        />
                      </Col>
                    )}
                  </Row>
                  {searchDate && (
                    <Row>
                      <Col>
                        <Row className="justify-content-start">
                          <Col
                            xs="auto"
                            tag={Flex}
                            className="p-3"
                            align="center"
                          >
                            <FontAwesomeIcon icon={faClock} className="mr-2" />
                          </Col>
                          <Col
                            xs="auto"
                            className="mr-2 bg-soft-light p-2 border-bottom"
                          >
                            <Label className="mb-0">Fecha</Label>
                            <Input
                              type="checkbox"
                              checked={dateFormat === "date"}
                              onChange={({ target }) => {
                                if (target.checked) {
                                  setDateFormat("date");
                                  setHourValue({
                                    start_at: null,
                                    end_at: null,
                                  });
                                } else {
                                  setDateFormat("time");
                                  setDateValue({
                                    start_at: null,
                                    end_at: null,
                                  });
                                }
                              }}
                              className="position-relative mr-2 ml-2 mt-0 mb-0"
                            />
                          </Col>
                          <Col
                            xs="auto"
                            className="mr-2 bg-soft-light p-2 border-bottom"
                          >
                            <Label className="mb-0">Hora</Label>
                            <Input
                              type="checkbox"
                              checked={dateFormat === "time"}
                              onChange={({ target }) => {
                                if (target.checked) {
                                  setDateFormat("time");
                                  setDateValue({
                                    start_at: null,
                                    end_at: null,
                                  });
                                } else {
                                  setDateFormat("date");
                                  setHourValue({
                                    start_at: null,
                                    end_at: null,
                                  });
                                }
                              }}
                              className="position-relative mr-2 ml-2 mt-0 mb-0"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {(dateFormat === "date" || dateFormat === "time") &&
                    searchDate && (
                      <Row>
                        <Col className="text-left" tag={FormGroup}>
                          <Label>
                            {dateFormat === "date"
                              ? "Rango de fecha"
                              : "Rango de tiempo"}
                          </Label>
                          <DatetimeRangePicker
                            startDate={
                              dateFormat === "date"
                                ? dateValue?.start_at
                                  ? dateValue?.start_at
                                  : moment()
                                : dateFormat === "time" && hourValue?.start_at
                                ? hourValue?.start_at
                                : moment()
                            }
                            endDate={
                              dateFormat === "date"
                                ? dateValue?.end_at
                                  ? dateValue?.end_at
                                  : moment()
                                : dateFormat === "time" && hourValue?.end_at
                                ? hourValue?.end_at
                                : moment()
                            }
                            pickerClassName="col-6 col-lg-6 col-md-12 col-sm-12 mb-sm-3 mb-md-3 mb-lg-0"
                            className="row"
                            isValidStartDate={(current, selectedDate) => {
                              if (dateFormat === "time") {
                                return current.isSame(moment(), "day");
                              }
                              return current;
                            }}
                            isValidEndDate={(current, selectedDate) => {
                              if (dateFormat === "time") {
                                return current.isSame(moment(), "day");
                              }
                              return current;
                            }}
                            onChange={({ start, end }) => {
                              if (dateFormat === "date") {
                                setDateValue({
                                  start_at: moment(start),
                                  end_at: moment(end),
                                });
                                setHourValue({
                                  start_at: null,
                                  end_at: null,
                                });
                              } else {
                                setHourValue({
                                  start_at: moment(start),
                                  end_at: moment(end),
                                });
                                setDateValue({
                                  start_at: null,
                                  end_at: null,
                                });
                              }
                            }}
                            dateFormat={
                              dateFormat === "date" ? "DD/MM/YYYY" : false
                            }
                            timeFormat={"[a las] h:mm A"}
                          />
                        </Col>
                      </Row>
                    )}
                  <Row>
                    <Col tag={Flex} align="center" justify="end">
                      <ButtonIcon
                        color="falcon-default"
                        icon={faSearch}
                        onClick={() => {
                          setParams((prev) => ({
                            ...prev,
                            condominium: selectedCondominium,
                            search_property:
                              role === "property"
                                ? null
                                : textProperty.trim() || null,
                            search_visitor: textVisitor.trim() || null,
                            entry_time_at:
                              searchDate &&
                              dateFormat === "time" &&
                              hourValue?.start_at &&
                              hourValue?.end_at
                                ? hourValue.start_at.format(
                                    "YYYY-MM-DD HH:mm:ss"
                                  )
                                : null,
                            departure_time_at:
                              searchDate &&
                              dateFormat === "time" &&
                              hourValue?.start_at &&
                              hourValue?.end_at
                                ? hourValue.end_at.format(
                                    "YYYY-MM-DD HH:mm:ss"
                                  )
                                : null,
                            entry_time_date:
                              searchDate &&
                              dateFormat === "date" &&
                              dateValue?.start_at &&
                              dateValue?.end_at
                                ? dateValue.start_at.format("YYYY-MM-DD")
                                : null,
                            departure_time_date:
                              searchDate &&
                              dateFormat === "date" &&
                              dateValue?.start_at &&
                              dateValue?.end_at
                                ? dateValue.end_at.format("YYYY-MM-DD")
                                : null,
                            departure_time: isOutside,
                          }));
                        }}
                      >
                        Buscar
                      </ButtonIcon>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody className={isIterableArray(data) ? "p-0 fs--1" : "fs--1"}>
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            <Or value={true}>
              <Table striped responsive>
                <thead>
                  <tr>
                    <th className="align-middle">Visitante</th>
                    <th className="align-middle">Propietario</th>
                    <th className="text-center align-middle">
                      Fecha y hora de entrada
                    </th>
                    <th className="text-center align-middle">
                      Fecha y hora de salida
                    </th>
                    {(role === "manager" || role === "safety") && (
                      <th className="text-center align-middle">Opciones</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {data.map(
                    (
                      {
                        id,
                        entry_time,
                        departure_time,
                        visitor: {
                          property,
                          data: { dni, firstname, lastname },
                        },
                      },
                      i
                    ) => (
                      <tr key={id}>
                        <td className="align-middle">
                          <Flex
                            align="start"
                            justify="center"
                            className="flex-column"
                          >
                            <b>
                              {dni?.charAt(0)}
                              <NumberFormat
                                displayType="text"
                                thousandSeparator
                                value={dni?.substring(1, 30)}
                              />
                            </b>
                            <p className="mb-0">
                              {firstname} {lastname}
                            </p>
                          </Flex>
                        </td>
                        <td className="align-middle">
                          <Flex
                            align="start"
                            justify="center"
                            className="flex-column"
                          >
                            <b>
                              {property?.dni?.charAt(0)}
                              <NumberFormat
                                displayType="text"
                                thousandSeparator
                                value={property.dni?.substring(1, 30)}
                              />
                            </b>
                            <p className="mb-0">
                              {property.firstname} {property.lastname}
                            </p>
                          </Flex>
                        </td>
                        <td className="text-center align-middle">
                          {moment(entry_time).format(
                            "DD/MM/YYYY [a las] h:mm A"
                          )}
                        </td>
                        <td className="text-center align-middle">
                          {departure_time ? (
                            moment(departure_time).format(
                              "DD/MM/YYYY [a las] h:mm A"
                            )
                          ) : (
                            <p className="mb-0">La salida no ha sido marcada</p>
                          )}
                        </td>
                        {(role === "manager" || role === "safety") && (
                          <td className="text-center align-middle">
                            <UncontrolledDropdown direction="left">
                              <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                              </DropdownToggle>
                              <DropdownMenu right>
                                <DropdownItem
                                  onClick={() => {
                                    setVisitorId(id);
                                    collapseOneOpen(true);
                                  }}
                                >
                                  <FontAwesomeIcon
                                    className="mr-2"
                                    icon={faCheck}
                                  />{" "}
                                  Marcar salida
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        )}
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </Or>
            <Or value={false} cond={!!error}>
              <Message
                className="p-3"
                color={"info"}
                icon={faInfoCircle}
                value={false}
              >
                <>
                  No hay {params.type === 1 ? "visitantes" : "autorizados"}{" "}
                  registrados.
                </>
              </Message>
              <Message
                className="p-3"
                color={"danger"}
                icon={faInfoCircle}
                value={true}
              >
                <>
                  Esta página no está disponible
                  <Button
                    data-testid="Button"
                    color="link"
                    size="sm"
                    className="ml-1 pl-0"
                    onClick={() => history.goBack()}
                  >
                    Volver
                  </Button>
                </>
              </Message>
            </Or>
          </PreloadState>
        </CardBody>
        {isIterableArray(data) && (
          <CardFooter>
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={params.type === 1 ? "visitantes" : "autorizados"}
              perPage={perPage}
            />
          </CardFooter>
        )}
      </Card>
      {handleModalConfirm()}
    </>
  );
};

export default VisitorsHistory;
